export const SET_FUNDING_STEP = 'SET_FUNDING_STEP'

export const FETCH_DISTRICT_FUNDING_DATA_PENDING = 'FETCH_DISTRICT_FUNDING_DATA_PENDING'
export const FETCH_DISTRICT_FUNDING_DATA_FULFILLED = 'FETCH_DISTRICT_FUNDING_DATA_FULFILLED'
export const FETCH_DISTRICT_FUNDING_DATA_REJECTED = 'FETCH_DISTRICT_FUNDING_DATA_REJECTED'

export const SAVE_DISTRICT_FUNDING_DATA_PENDING = 'SAVE_DISTRICT_FUNDING_DATA_PENDING'
export const SAVE_DISTRICT_FUNDING_DATA_FULFILLED = 'SAVE_DISTRICT_FUNDING_DATA_FULFILLED'
export const SAVE_DISTRICT_FUNDING_DATA_REJECTED = 'SAVE_DISTRICT_FUNDING_DATA_REJECTED'

export const SET_SAVED_DISTRICT_FUNDING_DATA = 'SET_SAVED_DISTRICT_FUNDING_DATA'

export const FETCH_CHILD_ORGS_PENDING = 'FETCH_CHILD_ORGS_PENDING'
export const FETCH_CHILD_ORGS_FULFILLED = 'FETCH_CHILD_ORGS_FULFILLED'
export const FETCH_CHILD_ORGS_REJECTED = 'FETCH_CHILD_ORGS_REJECTED'

export const FETCH_STATE_FUNDING_AND_PRICING_PENDING = 'FETCH_STATE_FUNDING_AND_PRICING_PENDING'
export const FETCH_STATE_FUNDING_AND_PRICING_FULFILLED = 'FETCH_STATE_FUNDING_AND_PRICING_FULFILLED'
export const FETCH_STATE_FUNDING_AND_PRICING_REJECTED = 'FETCH_STATE_FUNDING_AND_PRICING_REJECTED'

export const FETCH_DISTRICT_FUNDING_LOCK_DATE_PENDING = 'FETCH_DISTRICT_FUNDING_LOCK_DATE_PENDING'
export const FETCH_DISTRICT_FUNDING_LOCK_DATE_FULFILLED =
  'FETCH_DISTRICT_FUNDING_LOCK_DATE_FULFILLED'
export const FETCH_DISTRICT_FUNDING_LOCK_DATE_REJECTED = 'FETCH_DISTRICT_FUNDING_LOCK_DATE_REJECTED'

export const RESET_DISTRICT_FUNDING_DATA = 'RESET_DISTRICT_FUNDING_DATA'
export const SET_DISTRICT_FUNDING_CONTACT_INFO_DATA = 'SET_DISTRICT_FUNDING_CONTACT_INFO_DATA'
export const SET_DISTRICT_FUNDING_SCHOOL_SELECTION_DATA =
  'SET_DISTRICT_FUNDING_SCHOOL_SELECTION_DATA'
export const SET_DISTRICT_FUNDING_TYPE_DATA = 'SET_DISTRICT_FUNDING_TYPE_DATA'
export const SET_DISTRICT_FUNDING_SUBSIDY_DATA = 'SET_DISTRICT_FUNDING_SUBSIDY_DATA'

export const DELETE_DISTRICT_FUNDING_PENDING = 'DELETE_DISTRICT_FUNDING_PENDING'
export const DELETE_DISTRICT_FUNDING_FULFILLED = 'DELETE_DISTRICT_FUNDING_FULFILLED'
export const DELETE_DISTRICT_FUNDING_REJECTED = 'DELETE_DISTRICT_FUNDING_REJECTED'

export const TOTAL_FUNDING_STEPS = 5

export const FUNDING_CENTRAL_BILL = 'CENTRAL_BILLING'
export const FUNDING_SUBSIDY = 'SUBSIDIES'

export const CONTACT_INFORMATION_FORM_NAME = 'ContactInformationFundingForm'
export const CONTACT_INFORMATION_FORM_FIELDS = {
  fname: { name: 'firstName', required: true },
  lname: { name: 'lastName', required: true },
  phone: { name: 'phone', required: true },
  email: { name: 'email', required: true },
  ponumber: { name: 'purchaseOrderNumber', required: false },
  country: { name: 'country', required: true },
  addr1: { name: 'addr1', required: true },
  addr2: { name: 'addr2', required: false },
  city: { name: 'city', required: true },
  state: { name: 'state', required: true },
  zip: { name: 'zip', required: true },
}

export const SCHOOL_SELECTION_FORM_NAME = 'SchoolSelectionFundingForm'
export const SCHOOL_SELECTION_FORM_FIELDS = {
  excludeOrgs: { name: 'excludeOrgs', required: false },
  includeOrgs: { name: 'includeOrgs', required: true },
  excludeCharterSchools: { name: 'excludeCharterSchools', required: false },
}

export const FUNDING_CENTRAL_BILL_CONFIRMATION_FORM_NAME = 'confirmCentralBillFundingForm'
export const FUNDING_CENTRAL_BILL_CONFIRMATION_FORM_FIELDS = {
  confirmCentralBilling: { name: 'confirmCentralBilling', required: true },
}

export const FUNDING_SUBSIDY_CONFIGURATION_FORM_NAME = 'districtFundingSubsidyConfigurationForm'
export const FUNDING_SUBSIDY_CONFIGURATION_FORM_FIELDS = {
  feeReducedName: { name: 'feeReducedName', required: true },
  feeReducedId: { name: 'feeReducedId', required: false },
  feeReducedAmount: { name: 'feeReducedAmount', required: false },
  feeReducedMustTake: { name: 'feeReducedMustTake', required: false },
  feeReducedCancellationFeesActive: { name: 'feeReducedCancellationFeesActive', required: false },
  feeReducedCancellationFeesId: { name: 'feeReducedCancellationFeesId', required: false },
  feeReducedLateOrderFeesActive: { name: 'feeReducedLateOrderFeesActive', required: false },
  feeReducedLateOrderFeesId: { name: 'feeReducedLateOrderFeesId', required: false },
  feeReducedLateTestingFeesActive: { name: 'feeReducedLateTestingFeesActive', required: false },
  feeReducedLateTestingFeesId: { name: 'feeReducedLateTestingFeesId', required: false },
  standardFeeName: { name: 'standardFeeName', required: true },
  standardFeeId: { name: 'standardFeeId', required: false },
  standardFeeAmount: { name: 'standardFeeAmount', required: false },
  standardFeeMustTake: { name: 'standardFeeMustTake', required: false },
  standardFeeCancellationFeesActive: { name: 'standardFeeCancellationFeesActive', required: false },
  standardFeeCancellationFeesId: { name: 'standardFeeCancellationFeesId', required: false },
  standardFeeLateOrderFeesActive: { name: 'standardFeeLateOrderFeesActive', required: false },
  standardFeeLateOrderFeesId: { name: 'standardFeeLateOrderFeesId', required: false },
  standardFeeLateTestingFeesActive: { name: 'standardFeeLateTestingFeesActive', required: false },
  standardFeeLateTestingFeesId: { name: 'standardFeeLateTestingFeesId', required: false },
  invoiceDate: { name: 'invoiceAvailableDate', required: true },
}

export const OTHER_NONE = 'NONE'
export const LATE_ORDER = 'LATE_ORDER'
export const LATE_TESTING = 'LATE_TESTING'
export const CANCELLATION = 'CANCELLATION'

export const OTHER_FEES = {
  [LATE_ORDER]: 'Late Ordering Fees',
  [LATE_TESTING]: 'Late-Testing Fees',
  [CANCELLATION]: 'Cancellations Fees',
}
